'use client';

import { useEffect, useRef } from 'react';

export function VideoClient({
  hlsUrl,
  src,
  poster,
  width,
  height,
}: {
  hlsUrl?: string,
  src?: string,
  poster?: string,
  width?: number,
  height?: number,
}) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !src) return;
    video.play().catch(() => {});
  }, [src,]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !hlsUrl) return;

    let destroyed = false;

    import(`hls.js`).then(({ default: Hls, }) => {
      if (destroyed) return;

      if (Hls.isSupported()) {
        const hls = new Hls({
          lowLatencyMode: false,
          maxBufferLength: 30,
          backBufferLength: 30,
        });
        hls.loadSource(hlsUrl);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          if (!destroyed) video.play().catch(() => {});
        });

        (video as any)._hls = hls;
      } else if (video.canPlayType(`application/vnd.apple.mpegurl`)) {
        video.src = hlsUrl;
        video.play().catch(() => {});
      }
    });

    return () => {
      destroyed = true;
      const hls = (video as any)._hls;
      if (hls) {
        hls.destroy();
        (video as any)._hls = null;
      }
    };
  }, [hlsUrl,]);

  return (
    <video
      ref={videoRef}
      src={src}
      muted
      autoPlay
      loop
      playsInline
      poster={poster}
      style={{ width: `100%`, objectFit: `cover`, display: `block`, ...(width && height ? { aspectRatio: `${width}/${height}`, } : {}), }}
    />
  );
}
